import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'

const markdown = new MarkdownIt({
  html: true,
  xhtmlOut: true,
  breaks: true,
  linkify: true,
  typographer: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(str, { language: lang }).value
      } catch (__) {}
    }

    return '' // use external default escaping
  }
})

export default {
  methods: {
    renderMarkdown (text) {
      if ((typeof text !== 'undefined' && typeof text === 'string') || text instanceof String) {
        // Create a temporary DOM element to parse the text

        text = this.replaceNewlinesOutsideCodeBlocks(text, '<br>')
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = text

        this.traverseNodes(tempDiv)

        // Get the parsed HTML content
        let parsedHTML = tempDiv.innerHTML
        parsedHTML = this.replaceNewlinesForHTMLOutsideCodeBlocks(parsedHTML, '')

        if (text === parsedHTML) {
          const tempDiv2 = document.createElement('div')
          // replace <br> or <br /> with \n
          text = text.replace(/<br\s*\/?>/gm, '\n')
          tempDiv2.innerHTML = text.replace(/<[^>]*>?/gm, '')
          if (tempDiv2.innerHTML !== text) {
            this.traverseNodes(tempDiv2)

            // Get the parsed HTML content and remove \n if innerHTML is a table
            if (tempDiv2.innerHTML.startsWith('<table>')) {
              parsedHTML = tempDiv2.innerHTML
              parsedHTML = parsedHTML.replace(/\n/gm, '')
            }
          }
        }

        return parsedHTML
      }
      return text
    },
    traverseNodes (node) {
      const changes = []

      if (node.nodeType === 1 && (node.tagName === 'svg' || node.tagName === 'CODE')) {
        // Skip SVG and CODE elements
        return
      }

      node.childNodes.forEach(child => {
        if (child.nodeType === 3) { // Text node
          const markdownText = child.nodeValue

          let htmlContent = markdown.render(markdownText)
          const tempSpan = document.createElement('span')
          tempSpan.innerHTML = htmlContent

          if (tempSpan.childElementCount === 1 && tempSpan.firstChild.tagName === 'P') {
            // This prevents unnecessary wrapping of the text with additional <p> tags
            htmlContent = tempSpan.firstChild.innerHTML
          }

          // check if markdownText start or end with a space character or '&nbsp;' or unicode character
          if (/^( |&nbsp;|\u00A0)/.test(markdownText)) {
            htmlContent = ' ' + htmlContent
          }
          if (/( |&nbsp;|\u00A0)$/.test(markdownText)) {
            htmlContent = htmlContent + ' '
          }

          // remove \n after <li> to avoid breakline between the list number and the list content
          htmlContent = htmlContent.replace(/<li>\n/gm, '<li>')
          htmlContent = htmlContent.replace(/<ol>\n/gm, '<ol>')
          htmlContent = htmlContent.replace(/<\/ol>\n/gm, '</ol>')

          if (htmlContent.endsWith('\n')) {
            htmlContent = htmlContent.slice(0, -1)
          }
          changes.push({ oldInnerHtml: child, newInnerHTML: htmlContent })
        } else if (child.nodeType === 1) { // Element node
          this.traverseNodes(child)
        }
      })

      changes.forEach(change => {
        if (!(change.newInnerHTML && change.newInnerHTML === change.oldInnerHtml)) {
          // replace node child element matching change.oldInnerHtml with change.newInnerHTML
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = change.newInnerHTML

          let newChild
          if (tempDiv.childElementCount === 0 || (tempDiv.childElementCount === 1 && tempDiv.childNodes.length === 1)) {
            // this is needed to avoid wrapping each text_stream part with additional <div> tags
            newChild = tempDiv.firstChild
          } else {
            newChild = tempDiv
          }
          node.replaceChild(newChild, change.oldInnerHtml)
        }
      })
    },
    replaceNewlinesOutsideCodeBlocks (text, replacement) {
      const parts = text.split(/(```[\s\S]*?```)/) // Split by code blocks
      return parts.map(part => {
        if (part.startsWith('```') && part.endsWith('```')) {
          return part // Return code blocks unchanged
        } else {
          return part.replace(/\n\n/g, replacement) // Replace \n with <br> outside of code blocks
        }
      }).join('')
    },
    replaceNewlinesForHTMLOutsideCodeBlocks (text, replacement) {
      const parts = text.split(/(<code[\s\S]*?<\/code>)/) // Split by code blocks
      return parts.map(part => {
        if (part.startsWith('<code') && part.endsWith('</code>')) {
          return part // Return code blocks unchanged
        } else {
          return part.replace(/\n/g, replacement) // Replace \n with <br> outside of code blocks
        }
      }).join('')
    },
    linkify: function (text) {
      if ((typeof text !== 'undefined' && typeof text === 'string') || text instanceof String) {
        if (text.length) {
          if (text.trim() !== '') {
            var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig
            var urls = text.match(urlRegex)
            if (urls) {
              for (var i = 0; i < urls.length; i++) {
                var url = urls[i]
                var parts = text.split(url)
                if (parts[0].trim().length >= 6) {
                  var beforeURLText = parts[0].trim().substr(parts[0].trim().length - 6)
                  if (beforeURLText.indexOf('href=') === -1 && beforeURLText.indexOf('src=') === -1) {
                    text = text.replace(url, '<a href="' + url + '" target="_blank">' + url + '</a>')
                  }
                }
              }
            }
            var textToHTML = $jq('<div>').append(text)
            textToHTML.find('a').each(function () {
              // in case customer have inserted an anchor, tag make sure it is using the attribute "target"="_blank"
              $jq(this).attr('target', '_blank')
              // prevent tab key to focus on the link
              $jq(this).attr('tabindex', '-1')
            })
            textToHTML.find('area, button, iframe, input, select, summary, textarea, video controls').each(function () {
              // prevent tab key to focus on other standard elements
              $jq(this).attr('tabindex', '-1')
            })
            text = textToHTML.html()
          }
        }
      }
      return text
    },
    lineBreak: function (message) {
      if ((typeof message !== 'undefined' && typeof message === 'string') || message instanceof String) {
        message = message.replace(/(\r\n|\n|\r)/gm, '<br class="linebreak">')
        return message
      }
    },
    transformReferences(text) {
      return text.replace(/\[(\d+)\]/g, (match, number) => {
        return `<span class="citation" data-citation="${number}">${number}</span>`;
      });
    },
    reverseReferences(text) {
      return text.replace(/<span class="citation" data-citation="(\d+)">(\d+)<\/span>/g, (match, citationNumber, number) => {
        return `[${number}]`;
      });
    },
    addCitationsEventListeners() {
      this.$nextTick(() => {
        const container = this.$refs.cardItem
        if (!container) return;

        const citations = container.querySelectorAll(".citation");
        citations.forEach((el, index) => {
          el.addEventListener("mouseenter", (e) => this.openTopKOverlay(e));
          el.addEventListener("mouseleave", () => this.closeTopKOverlay());
          el.addEventListener("click", (e) => this.sendPostBack(e));
        });
      });
    },
    openTopKOverlay(e) {
      this.isTopKOverlayOpen = true;
      if (e) {
        this.hoveredCitation = e.target.getAttribute('data-citation') - 1
        const itemRect = e.target.getBoundingClientRect()
        let clientWidth = document.getElementById("webview-container").clientWidth
        let xPos = e.layerX > clientWidth / 2.5 ? itemRect.left - 300 : itemRect.right
        this.topKOverlayPosition = {
          x: xPos,
          y: itemRect.top - 40
        }
      }
    },
    closeTopKOverlay() {
      this.isTopKOverlayOpen = false;
    },
    sendPostBack (e) {
      if (e) {
        this.hoveredCitation = e.target.getAttribute('data-citation') - 1
        const citation = this.getCitation(this.hoveredCitation)
        if (!citation || !citation.buttons || citation.buttons.length === 0) {
          return
        }
        kserver.CoreAPI.sendMessage(citation.buttons[0].payload, 'POSTBACK')
      }
    },
    handlePasteShortcuts(e) {
      const isCmdOrCtrl = e.metaKey || e.ctrlKey
      const isV = e.key.toLowerCase() === 'v'

      if (isCmdOrCtrl && isV) {
        e.preventDefault()

        if (e.shiftKey) {
          // Paste without formatting
          this.pasteWithoutFormatting()
        } else {
          // Paste with formatting
          this.pasteWithFormatting()
        }
      }
    },
    pasteWithFormatting() {
      navigator.clipboard.readText().then(text => {
        const markdown = this.renderMarkdown(text)
        this.insertAtCursor(markdown)
      }).catch(err => {
        console.error('Clipboard read failed:', err)
      })
    },
    pasteWithoutFormatting() {
      navigator.clipboard.readText().then(text => {
        const cleanedText = DOMPurify.sanitize(text).replace(/<(.|\n)*?>/g, '')
        this.insertAtCursor(cleanedText)
      }).catch(err => {
        console.error('Clipboard read failed:', err)
      })
    },
    insertAtCursor(textToInsert) {
      const input = this.$refs.kaiInputPromptArea
      const value = input.value
      const start = input.selectionStart
      const end = input.selectionEnd

      const newValue = value.slice(0, start) + textToInsert + value.slice(end)
      this.$parent.userRequest.message = newValue

      // Move cursor to end of inserted text
      this.$nextTick(() => {
        input.selectionStart = input.selectionEnd = start + textToInsert.length
      })
    }
  }
}
